const MinusIcon = ({ size = 24, ...rest }) => (
  <svg
    fill="currentColor"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19,13H5a1,1,0,0,1,0-2H19a1,1,0,0,1,0,2Z"
    ></path>
  </svg>
);
const BellIcon = ({ size = 20, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M12.9167 15C12.9167 16.6108 11.6109 17.9167 10 17.9167C8.38921 17.9167 7.08337 16.6108 7.08337 15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0259 14.9997H3.97406C3.15996 14.9997 2.5 14.3397 2.5 13.5256C2.5 13.1347 2.6553 12.7598 2.93174 12.4833L3.43443 11.9806C3.90327 11.5118 4.16667 10.8758 4.16667 10.2128V7.91634C4.16667 4.69468 6.77834 2.08301 10 2.08301C13.2217 2.08301 15.8333 4.69467 15.8333 7.91634V10.2128C15.8333 10.8758 16.0967 11.5118 16.5656 11.9806L17.0682 12.4833C17.3447 12.7598 17.5 13.1347 17.5 13.5256C17.5 14.3397 16.84 14.9997 16.0259 14.9997Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const RoundedPlus = ({ size = 14, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_440_13524)">
      <path
        d="M12.8332 6.99984C12.8332 3.77817 10.2215 1.1665 6.99984 1.1665C3.77817 1.1665 1.1665 3.77817 1.1665 6.99984C1.1665 10.2215 3.77817 12.8332 6.99984 12.8332C10.2215 12.8332 12.8332 10.2215 12.8332 6.99984Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99984 4.6665V9.33317M9.33317 6.99984H4.6665"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_440_13524">
        <rect width={14} height={14} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const RoundedMinus = ({ size = 14, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_546_12664)">
      <path
        d="M18.3332 9.99938C18.3332 5.39697 14.6022 1.66602 9.99984 1.66602C5.39746 1.66602 1.6665 5.39697 1.6665 9.99938C1.6665 14.6017 5.39746 18.3327 9.99984 18.3327C14.6022 18.3327 18.3332 14.6017 18.3332 9.99938Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3334 10H6.66675"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_546_12664">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const FilledPlus = ({ size = 14, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_198_6106)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.729492 7.00033C0.729492 10.4636 3.53704 13.2712 7.00033 13.2712C10.4636 13.2712 13.2712 10.4636 13.2712 7.00033C13.2712 3.53704 10.4636 0.729492 7.00033 0.729492C3.53704 0.729492 0.729492 3.53704 0.729492 7.00033ZM7.00033 4.08366C7.3225 4.08366 7.58366 4.34483 7.58366 4.66699V6.41699H9.33366C9.65583 6.41699 9.91699 6.67815 9.91699 7.00033C9.91699 7.3225 9.65583 7.58366 9.33366 7.58366H7.58366V9.33366C7.58366 9.65583 7.3225 9.91699 7.00033 9.91699C6.67815 9.91699 6.41699 9.65583 6.41699 9.33366V7.58366H4.66699C4.34483 7.58366 4.08366 7.3225 4.08366 7.00033C4.08366 6.67815 4.34483 6.41699 4.66699 6.41699H6.41699V4.66699C6.41699 4.34483 6.67815 4.08366 7.00033 4.08366Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_198_6106">
        <rect width={14} height={14} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const AddIcon = ({ size = 14, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 1.75C7.32218 1.75 7.58333 2.01117 7.58333 2.33333V6.41667H11.6667C11.9888 6.41667 12.25 6.67782 12.25 7C12.25 7.32218 11.9888 7.58333 11.6667 7.58333H7.58333V11.6667C7.58333 11.9888 7.32218 12.25 7 12.25C6.67782 12.25 6.41667 11.9888 6.41667 11.6667V7.58333H2.33333C2.01117 7.58333 1.75 7.32218 1.75 7C1.75 6.67782 2.01117 6.41667 2.33333 6.41667H6.41667V2.33333C6.41667 2.01117 6.67782 1.75 7 1.75Z"
      fill="currentColor"
    />
  </svg>
);
const EditIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M5.44765 13.2189L13.2189 5.44771C13.5824 5.08421 13.7641 4.90247 13.8613 4.7064C14.0462 4.33337 14.0462 3.8954 13.8613 3.52236C13.7641 3.3263 13.5824 3.14455 13.2189 2.78105C12.8554 2.41755 12.6736 2.2358 12.4776 2.13864C12.1045 1.95379 11.6666 1.95379 11.2935 2.13864C11.0974 2.2358 10.9157 2.41755 10.5522 2.78105L2.78099 10.5523C2.39561 10.9376 2.20293 11.1303 2.10143 11.3753C1.99994 11.6203 1.99994 11.8929 1.99994 12.4379V13.9999H3.56203C4.10704 13.9999 4.37954 13.9999 4.62457 13.8985C4.86959 13.797 5.06228 13.6043 5.44765 13.2189Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 14H12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.66669 3.6665L12.3334 6.33317"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const CrossIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M13 3.5L3.00068 13.4993M12.9993 13.5L3 3.50071"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const FilledCrossIcon = ({ size = 20, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_1780_18812)">
      <mask
        id="mask0_1780_18812"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={size}
        height={size}
      >
        <path d="M20 0H0V20H20V0Z" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_1780_18812)">
        <path
          d="M10.0013 1.6665C5.40964 1.6665 1.66797 5.40817 1.66797 9.99984C1.66797 14.5915 5.40964 18.3332 10.0013 18.3332C14.593 18.3332 18.3346 14.5915 18.3346 9.99984C18.3346 5.40817 14.593 1.6665 10.0013 1.6665ZM12.8013 11.9165C13.043 12.1582 13.043 12.5582 12.8013 12.7998C12.6763 12.9248 12.518 12.9832 12.3596 12.9832C12.2013 12.9832 12.043 12.9248 11.918 12.7998L10.0013 10.8832L8.08464 12.7998C7.95964 12.9248 7.8013 12.9832 7.64297 12.9832C7.48464 12.9832 7.3263 12.9248 7.2013 12.7998C6.95964 12.5582 6.95964 12.1582 7.2013 11.9165L9.11797 9.99984L7.2013 8.08317C6.95964 7.8415 6.95964 7.4415 7.2013 7.19984C7.44297 6.95817 7.84297 6.95817 8.08464 7.19984L10.0013 9.1165L11.918 7.19984C12.1596 6.95817 12.5596 6.95817 12.8013 7.19984C13.043 7.4415 13.043 7.8415 12.8013 8.08317L10.8846 9.99984L12.8013 11.9165Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1780_18812">
        <rect width={20} height={20} fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
const FilterIcon = ({ size = 14, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M5.16685 7.29523C3.71526 6.20993 2.68079 5.01617 2.11595 4.34506C1.9411 4.13731 1.88381 3.98528 1.84936 3.71747C1.7314 2.80047 1.67242 2.34197 1.9413 2.04598C2.21019 1.75 2.68569 1.75 3.63669 1.75H10.3633C11.3143 1.75 11.7898 1.75 12.0587 2.04598C12.3276 2.34197 12.2686 2.80047 12.1507 3.71747C12.1162 3.98528 12.0589 4.13732 11.884 4.34506C11.3184 5.01703 10.2819 6.21291 8.82735 7.29954C8.69575 7.39789 8.60901 7.55808 8.59291 7.73582C8.44883 9.32867 8.31594 10.2011 8.23323 10.6425C8.09976 11.355 7.08937 11.7837 6.5485 12.1662C6.22656 12.3939 5.83584 12.1228 5.79412 11.7704C5.71458 11.0986 5.56477 9.73373 5.40124 7.73582C5.38655 7.55644 5.2995 7.39439 5.16685 7.29523Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const ListViewIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M5.33337 3.33301H13.3334"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M2.66663 3.33301H2.67261"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66663 8H2.67261"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66663 12.667H2.67261"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33337 8H13.3334"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M5.33337 12.667H13.3334"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
const GridViewIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M11.0014 3.99959C11.5639 3.99959 12.2133 3.94401 12.5341 4.49959C12.6681 4.73164 12.6681 5.04318 12.6681 5.66627V6.33294C12.6681 6.95601 12.6681 7.26754 12.5341 7.49961C12.2133 8.05514 11.5639 7.99961 11.0014 7.99961C10.4388 7.99961 9.78945 8.05514 9.46865 7.49961C9.33472 7.26754 9.33472 6.95601 9.33472 6.33294V5.66627C9.33472 5.04318 9.33472 4.73164 9.46865 4.49959C9.78945 3.94401 10.4388 3.99959 11.0014 3.99959Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.00138 3.99959C5.56398 3.99959 6.21331 3.94401 6.53408 4.49959C6.66808 4.73164 6.66808 5.04318 6.66808 5.66627V10.3329C6.66808 10.956 6.66808 11.2675 6.53408 11.4996C6.21331 12.0551 5.56398 11.9996 5.00138 11.9996C4.43879 11.9996 3.78946 12.0551 3.4687 11.4996C3.33472 11.2675 3.33472 10.956 3.33472 10.3329V5.66627C3.33472 5.04318 3.33472 4.73164 3.4687 4.49959C3.78946 3.94401 4.43879 3.99959 5.00138 3.99959Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const DownloadIcon = ({ size = 14, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M9.3334 7C9.3334 7 7.61496 9.33333 7.00007 9.33333C6.38518 9.33333 4.66675 7 4.66675 7M7.00007 9.04167V1.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.91678 4.66699C11.2055 4.66699 12.2501 5.71166 12.2501 7.00033V8.45866C12.2501 9.82051 12.2501 10.5014 11.9746 11.0169C11.7571 11.4239 11.4237 11.7572 11.0167 11.9748C10.5013 12.2503 9.82035 12.2503 8.45844 12.2503H5.54202C4.17993 12.2503 3.49889 12.2503 2.98337 11.9747C2.5765 11.7572 2.24324 11.424 2.02572 11.0171C1.75012 10.5016 1.75012 9.82051 1.75012 8.45843V6.99974C1.75044 5.71182 2.79421 4.66772 4.08213 4.66699H4.08346"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const ColorPickerIcon = ({ size = 14, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M8.17407 4.61068C8.39474 4.39 8.39474 4.03219 8.17407 3.81151C7.95339 3.59082 7.59558 3.59082 7.3749 3.81151L2.44162 8.74474C1.99933 9.18638 1.66784 9.51736 1.48979 9.94722C1.31174 10.3771 1.31209 10.8456 1.31255 11.4706L1.31259 12.1225C1.31259 12.4346 1.5656 12.6875 1.87769 12.6875L2.5296 12.6876C3.15463 12.6881 3.62309 12.6884 4.05293 12.5104C4.48278 12.3324 4.81378 12.0008 5.25542 11.5586L10.1887 6.62525C10.4093 6.40458 10.4093 6.04676 10.1887 5.82608C9.96799 5.60539 9.61018 5.6054 9.3895 5.82608L8.01114 7.20439C7.96057 7.25502 7.93525 7.28028 7.90311 7.29358C7.87097 7.30694 7.83521 7.30694 7.76364 7.30694H6.3228C5.96318 7.30694 5.78339 7.30694 5.73865 7.1989C5.6939 7.09087 5.82104 6.9637 6.07535 6.70943L8.17407 4.61068Z"
      fill="#212529"
    />
    <path
      d="M8.6887 1.47716C8.46914 1.25761 8.11319 1.25761 7.89368 1.47716C7.67411 1.6967 7.67411 2.05265 7.89368 2.27218L11.7276 6.10616C11.9472 6.32573 12.3032 6.32573 12.5227 6.10616C12.7422 5.88665 12.7422 5.53069 12.5227 5.31115L11.9848 4.77329C11.9463 4.73473 11.9467 4.67182 11.9852 4.6332L12.002 4.61645L12.0273 4.59118C12.167 4.45152 12.2731 4.34559 12.3511 4.23594C12.747 3.68001 12.747 2.93429 12.3511 2.37836C12.2731 2.2687 12.1671 2.16278 12.0273 2.02313L11.9767 1.97252C11.8371 1.83279 11.7311 1.72678 11.6215 1.64872C11.0656 1.25288 10.3198 1.25288 9.7639 1.64872C9.65424 1.7268 9.5483 1.8328 9.40865 1.97256L9.3834 1.99785L9.36665 2.01458C9.32804 2.05309 9.2651 2.05357 9.22654 2.015L8.6887 1.47716Z"
      fill="#212529"
    />
  </svg>
);
// Kanban board: header bar + three columns of cards (distinct from ColumnIcon used for Manage Columns)
const BoardViewIcon = ({ size = 14, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <rect x="1.75" y="1.75" width="12.5" height="12.5" rx="2.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M1.75 5H14.25" stroke="currentColor" strokeWidth="1.5" />
    <rect x="3.6" y="6.6" width="2.2" height="5.2" rx="0.8" fill="currentColor" />
    <rect x="6.9" y="6.6" width="2.2" height="3.4" rx="0.8" fill="currentColor" />
    <rect x="10.2" y="6.6" width="2.2" height="4.4" rx="0.8" fill="currentColor" />
  </svg>
);
const ColumnIcon = ({ size = 14, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M10.2084 2.9165C11.0277 2.9165 11.4373 2.9165 11.7316 3.11312C11.859 3.19824 11.9683 3.30762 12.0534 3.43501C12.2501 3.72927 12.2501 4.1389 12.2501 4.95817V9.62484C12.2501 10.4441 12.2501 10.8537 12.0534 11.148C11.9683 11.2754 11.859 11.3848 11.7316 11.4699C11.4373 11.6665 11.0277 11.6665 10.2084 11.6665C9.38912 11.6665 8.97951 11.6665 8.68527 11.4699C8.55787 11.3848 8.4485 11.2754 8.36339 11.148C8.16675 10.8537 8.16675 10.4441 8.16675 9.62484V4.95817C8.16675 4.1389 8.16675 3.72927 8.36339 3.43501C8.4485 3.30762 8.55787 3.19824 8.68527 3.11312C8.97951 2.9165 9.38912 2.9165 10.2084 2.9165Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M3.79167 2.9165C4.61093 2.9165 5.02057 2.9165 5.31483 3.11312C5.44222 3.19824 5.55159 3.30762 5.63671 3.43501C5.83333 3.72927 5.83333 4.1389 5.83333 4.95817V9.62484C5.83333 10.4441 5.83333 10.8537 5.63671 11.148C5.55159 11.2754 5.44222 11.3848 5.31483 11.4699C5.02057 11.6665 4.61093 11.6665 3.79167 11.6665C2.9724 11.6665 2.56276 11.6665 2.2685 11.4699C2.14111 11.3848 2.03174 11.2754 1.94662 11.148C1.75 10.8537 1.75 10.4441 1.75 9.62484V4.95817C1.75 4.1389 1.75 3.72927 1.94662 3.43501C2.03174 3.30762 2.14111 3.19824 2.2685 3.11312C2.56276 2.9165 2.9724 2.9165 3.79167 2.9165Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
const DeleteIcon = ({ size = 14, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M16.25 4.58398L15.7336 12.9382C15.6016 15.0727 15.5357 16.1399 15.0007 16.9072C14.7361 17.2866 14.3956 17.6067 14.0006 17.8473C13.2017 18.334 12.1325 18.334 9.99392 18.334C7.8526 18.334 6.78192 18.334 5.98254 17.8464C5.58733 17.6054 5.24667 17.2847 4.98223 16.9047C4.4474 16.1362 4.38287 15.0674 4.25384 12.93L3.75 4.58398"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M7.5 9.7793H12.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8.75 13.0449H11.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M2.5 4.58268H17.5M13.3796 4.58268L12.8107 3.40912C12.4328 2.62957 12.2438 2.23978 11.9179 1.99669C11.8457 1.94277 11.7691 1.8948 11.689 1.85327C11.3281 1.66602 10.8949 1.66602 10.0286 1.66602C9.1405 1.66602 8.6965 1.66602 8.32957 1.86112C8.24826 1.90436 8.17066 1.95427 8.09758 2.01032C7.76787 2.26327 7.5837 2.66731 7.21535 3.4754L6.71061 4.58268"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
const HamburgerIcon = ({ size = 20, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M3.33333 5H16.6667M3.33333 10H16.6667M3.33333 15H16.6667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ThreeDot = ({ size = 14, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M6.98949 7H7.00074M11.9888 7H12M2 7H2.01121"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const RoundedUser = ({ size = 14, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_103_5555)">
      <path
        d="M8.75 5.25C8.75 4.2835 7.96652 3.5 7 3.5C6.03347 3.5 5.25 4.2835 5.25 5.25C5.25 6.21652 6.03347 7 7 7C7.96652 7 8.75 6.21652 8.75 5.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8307 6.99984C12.8307 3.77817 10.219 1.1665 6.9974 1.1665C3.77573 1.1665 1.16406 3.77817 1.16406 6.99984C1.16406 10.2215 3.77573 12.8332 6.9974 12.8332C10.219 12.8332 12.8307 10.2215 12.8307 6.99984Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.91927 9.91667C9.91927 8.30585 8.61342 7 7.0026 7C5.39178 7 4.08594 8.30585 4.08594 9.91667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_103_5555">
        <rect width={14} height={14} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const RefreshIcon = ({ size = 16, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" {...rest}><path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" /><path d="M3 3v5h5" /><path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" /><path d="M16 16h5v5" /></svg>
);


const PrintIcon = ({ size = 14, ...rest }) => (
  <svg
    width={size}
    height={size}
    {...rest}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_138_4730)">
      <path
        d="M4.29111 10.5003C3.05263 10.5003 2.43338 10.5003 1.99251 10.236C1.70436 10.0632 1.47223 9.81613 1.32241 9.52278C1.09318 9.0739 1.1548 8.48042 1.27803 7.29345C1.3809 6.3026 1.43234 5.80715 1.68529 5.4433C1.85136 5.20441 2.07598 5.00862 2.33929 4.87322C2.74033 4.66699 3.25726 4.66699 4.29111 4.66699H9.71147C10.7454 4.66699 11.2623 4.66699 11.6633 4.87322C11.9266 5.00862 12.1513 5.20441 12.3173 5.4433C12.5703 5.80715 12.6217 6.3026 12.7246 7.29345C12.8478 8.48042 12.9094 9.0739 12.6802 9.52278C12.5304 9.81613 12.2983 10.0632 12.0101 10.236C11.5692 10.5003 10.95 10.5003 9.71147 10.5003"
        stroke="currentcolor"
      />
      <path
        d="M9.91536 4.66699V3.50033C9.91536 2.40038 9.91536 1.85041 9.57365 1.5087C9.23193 1.16699 8.68196 1.16699 7.58203 1.16699H6.41536C5.31542 1.16699 4.76545 1.16699 4.42374 1.5087C4.08203 1.85041 4.08203 2.40038 4.08203 3.50033V4.66699"
        stroke="currentcolor"
        strokeLinejoin="round"
      />
      <path
        d="M8.15877 9.33301H5.83862C5.43888 9.33301 5.239 9.33301 5.06893 9.39653C4.84218 9.48117 4.64802 9.64567 4.51732 9.86378C4.41929 10.0274 4.37081 10.2378 4.27386 10.6586C4.12236 11.316 4.04661 11.6448 4.09813 11.9084C4.16682 12.2598 4.38091 12.5573 4.6785 12.7148C4.90169 12.833 5.214 12.833 5.83862 12.833H8.15877C8.78341 12.833 9.09572 12.833 9.31891 12.7148C9.61647 12.5573 9.83061 12.2598 9.89927 11.9084C9.95077 11.6448 9.87506 11.316 9.72357 10.6586C9.62662 10.2378 9.57808 10.0274 9.48008 9.86378C9.34936 9.64567 9.15522 9.48117 8.92848 9.39653C8.75838 9.33301 8.55853 9.33301 8.15877 9.33301Z"
        stroke="currentcolor"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 7H10.5053"
        stroke="currentcolor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_138_4730">
        <rect width={14} height={14} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const WhatsAppIcon = ({ size = 16, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    {...rest}
  >
    <path
      fill="#fff"
      d="M4.868 43.303l2.694-9.835C5.9 30.59 5.026 27.324 5.027 23.979 5.032 13.514 13.548 5 24.014 5c5.079.002 9.845 1.979 13.43 5.566 3.584 3.588 5.558 8.356 5.556 13.428-.004 10.465-8.522 18.98-18.986 18.98h-.008c-3.177-.001-6.3-.798-9.073-2.311L4.868 43.303z"
    />

    <path
      fill="#fff"
      d="M4.868 43.803c-.132 0-.26-.052-.355-.148-.125-.127-.174-.312-.127-.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532 13.238 13.273 4.5 24.014 4.5c5.21.002 10.105 2.031 13.784 5.713 3.679 3.683 5.704 8.577 5.702 13.781-.004 10.741-8.746 19.48-19.486 19.48-3.189-.001-6.344-.788-9.144-2.277l-9.875 2.589c-.042.012-.084.017-.127.017z"
    />

    <path
      fill="#cfd8dc"
      d="M24.014 5c5.079.002 9.845 1.979 13.43 5.566 3.584 3.588 5.558 8.356 5.556 13.428-.004 10.465-8.522 18.98-18.986 18.98h-.008c-3.177-.001-6.3-.798-9.073-2.311L4.868 43.303l2.694-9.835C5.9 30.59 5.026 27.324 5.027 23.979 5.032 13.514 13.548 5 24.014 5z"
    />

    <path
      fill="#40c351"
      d="M35.176 12.832c-2.98-2.982-6.941-4.625-11.157-4.626-8.704 0-15.783 7.076-15.787 15.774-.001 2.981.833 5.883 2.413 8.396l.376.597-1.595 5.821 5.973-1.566.577.342c2.422 1.438 5.2 2.198 8.032 2.199h.006c8.698 0 15.777-7.077 15.78-15.776.001-4.215-1.639-8.179-4.619-11.161z"
    />

    <path
      fill="#fff"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.268 16.045c-.355-.79-.729-.806-1.068-.82-.277-.012-.593-.011-.909-.011-.316 0-.83.119-1.265.594-.435.475-1.661 1.622-1.661 3.956 0 2.334 1.7 4.59 1.937 4.906.237.316 3.282 5.259 8.104 7.161 4.007 1.58 4.823 1.266 5.693 1.187.87-.079 2.807-1.147 3.202-2.255.395-1.108.395-2.057.277-2.255-.119-.198-.435-.316-.909-.554s-2.807-1.385-3.242-1.543c-.435-.158-.751-.237-1.068.238-.316.474-1.225 1.543-1.502 1.859-.277.317-.554.357-1.028.119-.474-.238-2.002-.738-3.815-2.354-1.41-1.257-2.362-2.81-2.639-3.285-.277-.474-.03-.731.208-.968.213-.213.474-.554.712-.831.237-.277.316-.475.474-.791.158-.317.079-.594-.04-.831-.119-.237-1.041-2.583-1.463-3.521z"
    />
  </svg>
);

const RevisionIcon = ({ size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_139_8698)">
      <path
        d="M9.89406 5.23951C9.89266 3.51859 9.86664 2.6272 9.36562 2.01685C9.2689 1.89897 9.16081 1.7909 9.04298 1.69417C8.39903 1.16577 7.44243 1.16577 5.52908 1.16577C3.61575 1.16577 2.65909 1.16577 2.0152 1.69417C1.89732 1.79089 1.78923 1.89897 1.69249 2.01685C1.16406 2.6607 1.16406 3.6173 1.16406 5.53049C1.16406 7.4437 1.16406 8.40025 1.69249 9.04413C1.78923 9.16196 1.89732 9.27006 2.0152 9.36677C2.62559 9.86774 3.51704 9.89376 5.23807 9.89516"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.18175 5.26436L9.91174 5.2395M8.17358 12.8341L9.90351 12.8092M12.8153 8.1796L12.799 9.90609M5.2546 8.18753L5.23828 9.91397M6.6995 5.26436C6.2137 5.35137 5.43396 5.44087 5.2546 6.44518M11.3704 12.8092C11.8575 12.7297 12.6385 12.6522 12.8334 11.6507M11.3704 5.26436C11.8562 5.35137 12.636 5.44087 12.8153 6.44518M6.7069 12.8085C6.2211 12.7217 5.4413 12.6327 5.26139 11.6284"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_139_8698">
        <rect width={14} height={14} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export {
  MinusIcon,
  BellIcon,
  RoundedPlus,
  RoundedMinus,
  EditIcon,
  AddIcon,
  CrossIcon,
  FilterIcon,
  ListViewIcon,
  ColumnIcon,
  BoardViewIcon,
  GridViewIcon,
  ColorPickerIcon,
  DownloadIcon,
  DeleteIcon,
  ThreeDot,
  HamburgerIcon,
  FilledPlus,
  RefreshIcon,
  RoundedUser,
  FilledCrossIcon,
  PrintIcon,
  WhatsAppIcon,
  RevisionIcon,
};
